import type { InAppAgentRuntimeContext } from "@/services/inAppAgent/buildInAppAgentRuntimeContext";

let latestOpenworkContext: InAppAgentRuntimeContext | null = null;

/** Home / context layers publish the current OpenWork agent snapshot. */
export function publishOpenworkAgentContext(context: InAppAgentRuntimeContext): void {
  latestOpenworkContext = context;
}

/** Prefer the freshest published snapshot when sending a sidebar message. */
export function getLatestOpenworkAgentContext(): InAppAgentRuntimeContext | null {
  return latestOpenworkContext;
}

export function clearOpenworkAgentContext(): void {
  latestOpenworkContext = null;
}
